import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../../css/AdminContactUsFormsDashboard.css';

function AdminContactUsFormsDashboard() {
    const navigate = useNavigate();
    const [selectedStatus, setSelectedStatus] = useState('');
    const [statuses, setStatuses] = useState([]);
    const [contactForms, setContactForms] = useState([]);

    useEffect(() => {
        const fetchStatuses = async () => {
            try {
                const response = await axios.get('/api/admin/contact_form_statuses');
                if (Array.isArray(response.data.statuses)) {
                    setStatuses(response.data.statuses);
                    if (response.data.statuses.length > 0) {
                        setSelectedStatus(response.data.statuses[0].name);
                    }
                } else {
                    console.error('Expected an array but got:', response.data.statuses);
                }
            } catch (error) {
                console.error('Error fetching statuses:', error);
            }
        };

        fetchStatuses();
    }, []);

    useEffect(() => {
        const fetchContactForms = async () => {
            if (selectedStatus) {
                try {
                    const response = await axios.get(
                        `/api/admin/contact_forms?status=${encodeURIComponent(selectedStatus)}`
                    );
                    if (Array.isArray(response.data)) {
                        setContactForms(response.data);
                    } else {
                        console.error('Expected an array but got:', response.data);
                    }
                } catch (error) {
                    console.error('Error fetching companies:', error);
                }
            }
        };

        fetchContactForms();
    }, [selectedStatus]);

    return (
        <div className="adminContactUsFormsDashboardContainer">
            <div className="adminContactUsFormsDashboardHeaderContainer">
                <div className="adminContactUsFormsDashboardTitle">Contact Us Forms</div>
                <div className="adminContactUsFormsDashboardFilters">
                    {statuses.map((status) => (
                        <div key={status.id} className={`adminContactUsFormsDashboardFilter ${selectedStatus === status.name ? 'selected' : ''}`}
                             onClick={() => setSelectedStatus(status.name)}>
                            {status.name} ({status.count})
                        </div>
                    ))}
                </div>
            </div>
            <div className="adminContactUsFormsDashboardBodyContainer">
                <table className="adminContactUsFormsTable">
                    <thead>
                    <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Subject</th>
                        <th>Message</th>
                        <th>Create Date</th>
                        <th>Updated Date</th>
                        <th>Edited by</th>
                    </tr>
                    </thead>
                    <tbody>
                    {contactForms.map((contactForm) => (
                        <tr key={contactForm.id} onClick={() => navigate(`/admin/contact-form/${contactForm.id}`)}>
                            <td>{contactForm.id}</td>
                            <td>{contactForm.name}</td>
                            <td>{contactForm.email}</td>
                            <td>{contactForm.subject}</td>
                            <td>{contactForm.message}</td>
                            <td>{new Date(contactForm.created_at).toLocaleString()}</td>
                            <td>{new Date(contactForm.updated_at).toLocaleString()}</td>
                            <td>{contactForm.edited_by?.email}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default AdminContactUsFormsDashboard;
